export const getBrowserKey = (): string => {
  const userAgent: string = navigator.userAgent.toLowerCase();

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return "safari_ios";
  }
  if (/safari/.test(userAgent) && !/chrome|edg/.test(userAgent)) {
    return "safari_desktop";
  }
  if (/firefox/.test(userAgent)) {
    return "firefox";
  }
  return "chrome";
};

export const getBrowserVersion = (): string => {
  const userAgent: string = navigator.userAgent;

  // Firefox
  const firefoxMatch = userAgent.match(/Firefox\/(\S+)/);
  if (firefoxMatch) {
    return "Firefox: " + firefoxMatch[1];
  }

  // IE
  const msieMatch = userAgent.match(/MSIE (\S+);/);
  if (msieMatch) {
    return "IE: " + msieMatch[1];
  } else {
    // IE 11
    const tridentMatch = userAgent.match(/Trident\/7.0; rv:(\S+)/);
    if (tridentMatch) {
      return "IE: " + tridentMatch[1];
    }
  }

  // Chrome
  const chromeMatch = userAgent.match(/Chrome\/(\S+)/);
  if (chromeMatch) {
    return "Chrome: " + chromeMatch[1];
  }

  // Safari
  if (!chromeMatch) {
    const safariMatch = userAgent.match(/Safari\/(\S+)/);
    if (safariMatch) {
      const safariVersionMatch = userAgent.match(/Version\/(\S+)/);
      if (safariVersionMatch) {
        return "Safari: " + safariVersionMatch[1];
      } else {
        return "Safari: " + safariMatch[1];
      }
    }
  }

  return "Unknown browser version";
};
